module.exports = __webpack_public_path__ + "static/media/view1.488b8f7b.png";